export default __webpack_public_path__ + "static/media/ticket.a2c19846.svg";